import React from 'react'
import useTitle from '../../hooks/title'
import Layout from '../layout/Layout'
import { observer } from "mobx-react-lite"
import classes from './styles.module.scss'


const ShortcutsAndFx = observer(() => {
    useTitle('Shortcuts and FX');
  return <Layout className={classes.help}>
    <div className={classes['container']}>
        <div className={classes['content']}>
            <div className={classes['head1']}>
                <h1>Shortcuts</h1>
            </div>

            <div className={classes['head2']}>
                <h2>Preset Page</h2>
            </div>

            <div className={classes['paragraph']}>
                <ul>
                    <li>Up and down arrow to select and space bar to audition certain presets</li>
                    <li>Press Enter key to open the Loops Editor</li>
                </ul>
            </div>

            <div className={classes['head2']}>
                <h2>Loop Editor</h2>
            </div>

            <div className={classes['paragraph']}>
                <ul>
                    <li>Click on any groove in groove list or editing area to start audition them. While select a groove in groove list, you can use up and down arrow to select different grooves.</li>
                    <li>Press space bar to play or stop playing a loop</li>
                    <li>Select a clip and press delete button to delete certain clips</li>
                    <li>Holding Alt(Windows)/Option(Mac) while dragging a groove in editing area will duplicate it. Holding Ctrl(Windows)/Cmd(Mac) while moving your mouse over a groove, you can split a groove by clicking over the spot you want.</li>
                </ul>
                <p>Enjoy it!</p>
            </div>

            <div className={classes['head1']}>
                <h1>FX</h1>
            </div>
            
            <div className={classes['head2']}>
                <h2>Analog Echo</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Delay; Channels: Mono. This model captures the characteristics of the sound of a vintage analog delay machine: warm and natural, just like old times! <br/>
                Presets:</p>
                <ul>
                    <li>Analog Echo (8th note, heavy)</li>
                    <li>Analog Echo (quarter note, heavy)</li>
                    <li>Analog Echo (dotted 8th note, heavy)</li>
                    <li>Analog Echo (dotted quarter note, heavy)</li>
                    <li>Analog Echo (8th note, light)</li>
                    <li>Analog Echo (quarter note, light)</li>
                    <li>Analog Echo (dotted 8th note, light)</li>
                    <li>Analog Echo (dotted quarter note, light)</li>
                </ul>
            </div>
            <div className={classes['head2']}>
                <h2>Chorus</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Chorus; Channels: Stereo. This Dream, Sweet vintage analog chorus model is based on the lengendary 2-knob blue ensemble chorus unit, which offers you a tone that is pure, lush and warm.  <br/>
                Presets:</p>
                <ul>
                    <li>Chorus (full)</li>
                    <li>Chorus (half)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Cloud Reverb</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Reverb; Channels: Stereo. This is a finely-tuned, musical model that takes you to shining reverb heights while keeping the highs under control.  <br/>
                Presets:</p>
                <ul>
                    <li>Cloud Reverb (long heavy)</li>
                    <li>Cloud Reverb (long light)</li>
                    <li>Cloud Reverb (short heavy)</li>
                    <li>Cloud Reverb (short light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Tremolo</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Tremolo; Channels: Mono.  Will be the tremolo after your own heart.<br/>
                Presets:</p>
                <ul>
                    <li>Tremolo (8th note, heavy)</li>
                    <li>Tremolo (16th note, heavy)</li>
                    <li>Tremolo (8th note, light)</li>
                    <li>Tremolo (16th note, light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Rotary</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Rotary/Flanger; Channels: Stereo. This model delivers a lush rotating effect that simulates 1960s rotary speakers. Based on the Voodoo Lab® Micro Vibe*, it gives you the pure, “psychedelic” vibe-y taste that guitar heroes like Hendrix and Gilmour loved. <br/>
                Presets:</p>
                <ul>
                    <li>Rotary (quarter note, heavy)</li>
                    <li>Rotary (quarter note, light)</li>
                    <li>Rotary (8th note, heavy)</li>
                    <li>Rotary (8th note, light)</li>
                    <li>Rotary (16th note, heavy)</li>
                    <li>Rotary (16th note, light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Ocean Reverb</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Reverb; Channels: Stereo.  This is a finely-tuned,musical model that immerses you in a deep reverb  without messing up your sound. <br/>
                Presets:</p>
                <ul>
                    <li>Ocean Reverb (short light)</li>
                    <li>Ocean Reverb (short heavy)</li>
                    <li>Ocean Reverb (long light)</li>
                    <li>Ocean Reverb (long heavy)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Reversing Machine</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Reverse Delay; Channels: Mono. This is a delay model that reverses the original sound. It’s like we recorded your sound with a tape recorder and then played it backwards. That’s where this model goes.<br/>
                Presets:</p>
                <ul>
                    <li>Reversing Machine (quarter note, heavy)</li>
                    <li>Reversing Machine (quarter note, light)</li>
                    <li>Reversing Machine (8th note, heavy)</li>
                    <li>Reversing Machine (8th note, light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Tape Saturator</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Saturation; Channels: Mono. This model is a tape saturation simulator that simulates the sound character of a vintage reel-to-reel tape recorder, bringing you unbeatable analog warmth and natural distortion.  <br/>
                Presets:</p>
                <ul>
                    <li>Tape Saturator (heavy)</li>
                    <li>Tape Saturator (light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Vibrato</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Vibrato; Channels: Stereo.  A vibrato effect is an effect which had been mistakenly given the meaning of tremolo. In fact, a vibrato effect is a pitch modulation that changes the pitch of your tone. This model is a typical vibrato effect with a wide controllable range. <br/>
                Presets:</p>
                <ul>
                    <li>Vibrato (fast heavy)</li>
                    <li>Vibrato (fast light)</li>
                    <li>Vibrato (slow heavy)</li>
                    <li>Vibrato (slow light)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Stone Phaser</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Phaser; Channels: Mono. The Stone Phaser is based on the legendary and extremely rare 1970s Electro-Harmonix Small Ston ephase shifter (v2) pedal. This original is on eof the best analog phaser sounds in the history of music and can be heard on countless rock recordings.<br/>
                Presets:</p>
                <ul>
                    <li>Stone Phaser (Fast)</li>
                    <li>Stone Phaser (Slow)</li>
                    <li>Stone Phaser (whole note)</li>
                    <li>Stone Phaser (quarter note)</li>
                    <li>Stone Phaser (8th note)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Ensemble</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Chorus; Channels: Mono. The Spatial Ensemble is based on the famous Maxon® CS-550 Stereo Chorus* pedal, featuring a wide ranged, edgy stereo chorus tone that stands out from other chorus units.  <br/>
                Presets:</p>
                <ul>
                    <li>Ensemble (full)</li>
                    <li>Ensemble (half)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Sweep Delay</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>Type: Delay effect with sweeping filter; Channels: Stereo. This delay model has a sweep filter affecting the delay repeats, which creates a unique sweeping delay sound. <br/>
                Presets:</p>
                <ul>
                    <li>Sweep Delay (Defualt)</li>
                    <li>Sweep Delay (whole note trem)</li>
                    <li>Sweep Delay (8th note trem)</li>
                    <li>Sweep Delay (quarter note trem, light delay)</li>
                    <li>Sweep Delay (quarter note trem, heavy delay)</li>
                </ul>
            </div>
            
            <div className={classes['head2']}>
                <h2>Combo FX</h2>
            </div>

            <div className={classes['paragraph']}>
                <p>You can guess what it is from its name pretty easy. Here's some details.</p>
                <ul>
                    <li>[Echo Chorus] Analog Echo and Chorus.</li>
                    <li>[Echo Ensemble] Analog Echo and Ensemble</li>
                    <li>[Echo Ocean] Analog Echo and Ocean Reverb</li>
                    <li>[Echo Stone] Analog Echo and Stone Phaser</li>
                    <li>[Echo Vibrato] Analog Echo and Vibrato</li>
                    <li>[Reversing Chorus] Reversing Machine</li>
                    <li>[Reversing Cloud] Reversing Machine and Coud Reverb</li>
                    <li>[Reversing Ensemble] Reversing Machine and Ensemble</li>
                    <li>[Reversing Ocean] Reversing Machine and Ocean Reverb</li>
                    <li>[Reversing Rotary] Reversing Machine and Rotary</li>
                    <li>[Reversing Stone] Reversing Machine and Stone Phaser</li>
                    <li>[Reversing Vibrator] Reversing Machine and Vibrato</li>
                    <li>[Sweep Ocean] Sweepdelay and Ocean Reverb</li>
                    <li>[Tape Cloud] Saturator and Cloud Reverb</li>
                    <li>[Tape Echo] Saturator and Analog Echo</li>
                </ul>
            </div>
            
        </div>
    </div>
  </Layout>
})

export default ShortcutsAndFx